import { Children, Stylable } from 'utils/types'
import { StyledButton } from './styles'

interface ButtonProps extends Stylable, Children {
  onClick?: () => void
  disabled?: boolean
  outlined?: boolean
}

export const Button = ({ children, disabled, onClick, style, className, outlined }: ButtonProps) => (
  <StyledButton disabled={disabled} style={style} className={className} onClick={onClick} $outlined={outlined}>
    {children}
  </StyledButton>
)
